import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_EMAR_FULL_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import DatePicker from "react-datepicker";
import {
  getRecords,
  isSuccess,
  filterColumns,
  catchAsync,
  addActivityLog,
} from "../../../../helper/helper";
import moment from "moment";
import Input from "../../../../components/forms-fields/Input";

function EmarFull() {

  const [filteredRows, setFilteredRows] = useState([]);
  // console.log("🚀 ~ EmarFull ~ filteredRows:", filteredRows)
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState(moment().startOf('month').valueOf());
  const [endDate, setEndDate] = useState(moment().endOf('month').valueOf());
  const [apiQuery, setApiQuery] = useState({
    startDate: startDate,
    endDate: endDate,
  });
  useEffect(() => {
    setApiQuery({
      startDate: moment(startDate).valueOf(),
      endDate: moment(endDate).valueOf(),
    });
  }, [startDate, endDate]);
  // console.log("🚀 ~ EmarFull ~ apiQuery:", apiQuery)

  useEffect(() => {
    fetchAllRecords({
      startDate: moment(startDate).valueOf(),
      endDate: moment(endDate).valueOf(),
    });
  }, [startDate, endDate]);

  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
    } else if (method === "get" && data?.status === isSuccess) {
      const staffMembers = data?.data
      setFilteredRows(staffMembers);
      setIsLoading(false);
    }
  };

  const fetchAllRecords = catchAsync(async (query) => {
    // debugger
    const response = await getRecords(GET_EMAR_FULL_REPORT, query);
    console.log("🚀 ~ fetchAllRecords ~ response:", response)

    processFetchRecords("get", response);
  });

  useEffect(() => {
    fetchAllRecords();
  }, []);

  const columns = [
    {
      name: "#",
      selector: (row, index) => (
        <span >
          {index + 1}
        </span>
      ),
      width: "5%",
      center: true,
    },
    {
      name: "Service User",
      selector: (row) => {
        return (
          <>

            {row?.suFirstMiddleName}&nbsp;
            {row?.suLastName}
          </>
        );
      },
    },
    {
      name: "Medication Name",
      selector: (row) => {
        return (
          <div
            className="usersNameInfo py-2"
          >
            <span className="userInfo">
              <span className="nameBlock">{row?.medicationName}</span>
              <small className="nameBlock">Type: {row?.medicationType}</small>
            </span>
          </div>
        );
      },
    },
    {
      name: "Date & Time",
      selector: (row) => {
        return (
          <div
            className="usersNameInfo py-2"
          >
            <span className="userInfo">

              <small className="nameBlock"> Actual Time:{row?.actualDoseTime}</small>
              <small className="nameBlock"> Date:{row?.date}</small>
              <small className="nameBlock"> Day:{row?.day}</small>
              <small className="nameBlock"> Time:{row?.doseTime}</small>


            </span>
          </div>
        );
      },
    },
    {
      name: "Marked By",
      selector: (row) => {
        return (
          <div
            className="usersNameInfo py-2"
          >
            <span className="userInfo">
              <span className="nameBlock">{row?.markedBy}</span>
              <small className="nameBlock"> Time:{row?.markedTime}</small>
            </span>
          </div>
        );
      },
    },
    {
      name: "Prescriber Name",
      selector: (row) => {
        return (
          <span className="text-capitalize">
            {row?.prescriberName}
          </span>
        );
      },
      wrap: true,
      center: true
    },
    {
      name: "Status",
      selector: (row) => {
        return (
          <span className="text-capitalize">
            {row?.status}
          </span>
        );
      },
      wrap: true,
      center: true
    },
  ];

  const filteredColumns = filterColumns(columns, (column) => column !== null);



  const styles = StyleSheet.create({
    pages: {
      padding: "10px",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "black",
      marginBottom: "5px",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#f0f0f0"
    },
    sectionSubTitle: {
      fontSize: "14px",
      fontWeight: "black",
      marginBottom: "5px",
      textAlign: "center",
      padding: "10px",
      backgroundColor: "#f0f0f0"
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    tableHead: {
      flexDirection: "row",
      justifyContent: "space-between",
      backgroundColor: "#f0f0f0",
      padding: "10px 10px",
      marginBottom: "5px",
      fontSize: "10px",
      fontWeight: "bold",
      wordWrap: "break-word",
    },
    tabBody: {
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "10px 10px",
      borderBottom: "1px solid #ccc",
      fontSize: "10px",
      wordWrap: "break-word",
    },
    wordwrap: {
      flexBasis: "50%",
      wordWrap: "break-word",
    },
  });

  const MyDocument = (start) => (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.pages}>
        <View>
          <Text style={styles.sectionTitle}>eMAR Administration - Full {moment(startDate).format("DD/MM/YYYY")} to {moment(endDate).format("DD/MM/YYYY")}</Text>
          <View style={styles.tableHead}>
            <Text style={{ width: "20%" }}>Service User</Text>
            <Text style={{ width: "20%" }}>Medication Name</Text>
            <Text style={{ width: "25%" }}>Date & Time</Text>
            <Text style={{ width: "20%" }}>Marked By</Text>
            <Text style={{ width: "15%" }}>Prescriber Name</Text>
            <Text style={{ width: "10%" }}>Status</Text>
          </View>
          {filteredRows.map((row, index) => (
            <View key={index} style={styles.tabBody}>
              <Text style={{ width: "20%" }}>
                {row?.suFirstMiddleName}&nbsp;
                {row?.suLastName}
              </Text>
              <Text style={{ width: "20%" }}>
                {row.medicationName}{"\n"}
                Type: {row.medicationType}
              </Text>
              <Text style={{ width: "25%" }}>
                Actual Time:{row?.actualDoseTime}{"\n"}
                Date:{row?.date}{"\n"}
                Day:{row?.day}{"\n"}
                Time:{row?.doseTime}
              </Text>
              <Text style={{ width: "20%" }}>
                {row?.markedBy}{"\n"}
                Time:{row?.markedTime}
              </Text>
              <Text style={{ width: "15%" }}>{row.prescriberName}</Text>
              <Text style={{ width: "10%" }}>{row.status}</Text>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
    const handleExport = () => {
      // Preprocess data to format dates before exporting
      const formattedData = data.map(
        ({
          ...item
        }) => {
          removeMoreColumns.forEach((column) => {
            delete item[column];
          });

          // const startDate = moment(item?.medicationStartDate).format("DD/MM/YYYY");
          // const endDate = moment(item?.medicationEndDate).format("DD/MM/YYYY");
          // const serviceUserName = item?.serviceUser?.name
          //   && `${item?.serviceUser?.name} ${item?.serviceUser?.modelId?.suLastName}`;

          return {
            ...item,
            // medicationStartDate: startDate,
            // medicationEndDate: endDate,
            // serviceUser: serviceUserName
          };
        }
      );

      const formattedData2 = [{ "eMAR Administration - Full": patientName }];

      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const fileName = patientName;

      // Convert dataWithTitles array to worksheet
      let ws = XLSX.utils.json_to_sheet(formattedData2);

      // Add second data set to existing worksheet
      const ws2 = XLSX.utils.json_to_sheet(formattedData, {
        header: Object.keys(formattedData[0]),
        skipHeader: true,
      });

      XLSX.utils.sheet_add_json(ws, formattedData, {
        header: Object.keys(formattedData[0]),
        skipHeader: false,
        origin: -1,
      });

      // Create workbook
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

      // Write workbook to array buffer
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

      // Convert array buffer to Blob
      const blob = new Blob([excelBuffer], { type: fileType });

      // Create download link and trigger download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName + fileExtension;
      a.click();
      // Add activity log AFTER download
      addActivityLog({
        message: `Download in Excell`,
        module: "eMAR Administration - Full",
      });
    };

    return <span onClick={handleExport}>Export as xlsx</span>;
  };

  return (
    <>

      <Layout pageTitleText="eMAR Administration - Full">
        <header className="headerContainerSearchAction staffHolidayRequests">
          <div className="dateInput">
            <div className="dateBlock">
              <div className={`form-group`}>
                <DatePicker
                  selected={new Date(startDate)} // Pass a Date object
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    if (date) setStartDate(moment(date).valueOf()); // convert to timestamp
                  }}
                  className="datePicker"
                  isClearable={false}
                />
              </div>
              <div className={`form-group`}>
                <DatePicker
                  selected={new Date(endDate)} // Pass a Date object
                  dateFormat="dd/MM/yyyy"
                  onChange={(date) => {
                    if (date) setEndDate(moment(date).valueOf()); // convert to timestamp
                  }}
                  className="datePicker"
                  isClearable={false}
                />
              </div>
            </div>
          </div>
          <div className="actionButtons">
            <div className="gap-1">
              <a className="btn btn-sm btn-primary" href="/reports">
                Back to Reports
              </a>
              <>
                {
                  filteredRows.length > 0 && (
                    <Dropdown>
                      <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                        Export Data
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="exportDataList">
                        <>
                          <span className="">
                            <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"eMAR Administration - Full"}>
                              {({ loading }) =>
                                loading ? (
                                  "..."
                                ) : (
                                  <span
                                    onClick={() =>
                                      addActivityLog({
                                        message: "Download in PDF",
                                        module: "eMAR Administration - Full",
                                      })
                                    }
                                  >
                                    Export as PDF
                                  </span>
                                )
                              }
                            </PDFDownloadLink>
                          </span>
                          <span className="">
                            <ExportButton data={filteredRows} patientName={"eMAR Administration - Full" + " " + moment(startDate).format("DD/MM/YYYY") + " " + moment(endDate).format("DD/MM/YYYY")} removeMoreColumns={["lastModifiedBy", "hldRqReason", "active", "_id", "__v", "updatedAt", "createdAt", "addedby", "medicationScheduleId", "doseId", "suPreferredName", "", "", "", "", "", "", "", "", "", "", "profile_picture_url"]} />
                          </span>
                        </>

                      </Dropdown.Menu>
                    </Dropdown>
                  )
                }
              </>
            </div>
          </div>
        </header>
        {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
          <MyDocument />
        </PDFViewer> */}

        <div className="mainContent h-100 noCursorPointer">
          <div className="dataTableWrapper staffRecordsGroupsTable minHeight300">
            <DataTable
              className="maxWidthTable"
              columns={filteredColumns}
              data={filteredRows}
              fixedHeader
              fixedHeaderScrollHeight="520px"
              highlightOnHover
              responsive={true}
              subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
              progressPending={isLoading}
              progressComponent={<ProgressComponent />}
            />
          </div>
        </div>
      </Layout >
    </>
  );
}

export default EmarFull;
